<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items-per-page="5"
            :items="items"
            item-key="no"
            >
            <template  v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>รายละเอียดงานช่าง</v-toolbar-title>
                    <v-divider
                    class="mx-4"
                    inset
                    vertical
                    ></v-divider>
                    
                    <v-spacer></v-spacer>

                    <v-dialog v-model="dialog" max-width="700px">
                        <template v-slot:activator="{ on, attrs }" v-if="canEdit">
                            <v-btn
                            v-if="!isStopState"
                            color="primary"
                            dark
                            class="mb-2"
                            v-bind="attrs"
                            v-on="on"
                            >เพิ่ม</v-btn>
                        </template>
                        <v-card outlined>
                            <v-card-title ><strong>เพิ่ม/แก้ไขรายละเอียดงานช่าง</strong></v-card-title>
                            <v-divider class="ma-2"></v-divider>
                            <div class="pl-5 pr-5">
                                <v-form ref="formDetail" v-model="validDetail" lazy-validation>
                                <v-row v-if="editedIndex < 0">
                                    <v-col>
                                        <v-autocomplete
                                            autofocus
                                            :rules="[rules.required]"
                                            v-model="editedItem.serviceDetailCode"
                                            :items="serviceDetailFilter"
                                            item-text="name"
                                            item-value="value"
                                            outlined 
                                            placeholder="พิมพ์รหัส หรือ ชื่อขั้นตอน"
                                            label="ขั้นตอน">
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-autocomplete
                                            :rules="[rules.required]"
                                            v-model="editedItem.empCode"
                                            :items="empList"
                                            item-text="name"
                                            item-value="value"
                                            outlined 
                                            placeholder="พิมพ์รหัส หรือ ชื่อช่าง"
                                            label="ชื่อช่าง">
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="8">
                                        <v-radio-group v-model="serviceStatus" row>
                                            <v-radio 
                                            v-if="editedItem.serviceDetailCode != 9 &&
                                             !(editedItem.jobServiceDetailId > 0 && editedItem.finishDate)" label="กำลังดำเนินการ" value="0"></v-radio>
                                            <v-radio label="ดำเนินการเสร็จ" value="1"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-checkbox v-model="editedItem.revise" label="งานแก้ไข"></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row v-if="editedItem.serviceDetailCode != 9">
                                    <v-col>
                                        <DatePicker 
                                        ref="startDate"
                                        label="วันที่เริ่มงาน" 
                                        :maxDate="getMaxDate"
                                        @dateFormatted="setStartDate" >
                                        </DatePicker>
                                    </v-col>
                                    <v-col>
                                        <v-text-field outlined 
                                            placeholder=" " 
                                            label="เวลา"
                                            v-mask="'##:##'"
                                            :rules="[rules.requiredTime]"
                                            v-model="editedItem.startTime">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                
                                <v-row v-if="serviceStatus == '1'">
                                    <v-col>
                                        <DatePicker 
                                        ref="finishDate"
                                        label="วันที่ซ่อมเสร็จ"
                                        :minDate="getMinDate" 
                                        @dateFormatted="setFinishDate" >
                                        </DatePicker>
                                    </v-col>
                                    <v-col>
                                        <v-text-field outlined 
                                            placeholder=" " 
                                            label="เวลา" 
                                            :rules="[rules.requiredTime]"
                                            v-mask="'##:##'"
                                            v-model="editedItem.finishTime">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field outlined 
                                            placeholder=" " 
                                            label="หมายเหต"
                                            maxlength="200"
                                            v-model="editedItem.remark">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                </v-form> 
                            </div>
                            <v-card-actions class="text-right">
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="saveDetail">บันทึก</v-btn>
                                <v-btn color="primary" @click="closeDialog"> ยกเลิก</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>

            <template v-if="canEdit" v-slot:item.action="{ item }">
                <v-icon
                        small
                        @click="editItem(item)"
                    >
                        edit
                    </v-icon>
                    <v-icon
                        small
                        @click="deleteItem(item)"
                    >
                        delete
                    </v-icon>
                </template>
        </v-data-table>
    </v-container>
</template>

<script>
import {deleteJobServiceDetail} from '@/api/job/job-api.js'
import {listTechnicial, listServiceDetail} from '@/api/common/dropdown-api.js'
import DatePicker from '@/components/Shared/DatePicker'
import rules from '@/assets/js/rules.js'
import {parseDate} from '@/assets/js/common.js'
import moment from 'moment'
import dialog from '@/assets/js/dialog.js'
export default {
    name: 'Tab3',
    components: {
        DatePicker
    },
    computed: {
        serviceDetailFilter() {

            if (this.items == undefined || this.items.length <= 0) {
                return this.serviceDetailList.filter(o => parseInt(o.value) < 9 || o.value.trim() == '10');
            }

            if (this.maxServiceDetailCode == '10' && this.items[this.items.length -1].strEndTime) {
                return this.serviceDetailList;
            }

            if (this.canFinishJob && parseInt(this.maxServiceDetailCode) >= 9) return [];
            
            
            if (this.isWaiting && !this.isEdited) {
                if (this.canFinishJob) {
                    return this.serviceDetailList;
                    //return this.serviceDetailList.filter(o => parseInt(o.value) > parseInt(this.maxServiceDetailCode) || o.value.trim() == '10') ;
                } else {
                    return this.serviceDetailList.filter(o =>  parseInt(o.value) < 9 || o.value.trim() == '10') ;
                    //return this.serviceDetailList.filter(o => parseInt(o.value) > parseInt(this.maxServiceDetailCode) && parseInt(o.value) < 9 || o.value.trim() == '10') ;
                }
            } else {
                if (this.maxServiceDetailCode == '10') return [];
                //return this.serviceDetailList;
                return this.serviceDetailList.filter(o => parseInt(o.value) == parseInt(this.maxServiceDetailCode)) ;
            }

        }, 
        getMinDate() {
            return parseDate(this.editedItem.startDate);
        },
        getMaxDate() {
            if (this.serviceStatus == '1' && this.editedItem.finishDate) {
                return parseDate(this.editedItem.finishDate);
            }
            return "";
        }
    },
    watch: {
        items: {
            handler(data){
                this.$emit("syncJobServiceDetail", data);
            },
            deep: true
        },
        dialog(val) {
            this.maxServiceDetailCode = '';
            if (val && this.items && this.items.length > 0) {
                //this.maxServiceDetailCode = Math.max.apply(Math, this.items.map(function(o) { return parseInt(o.serviceDetailCode); }));
                this.maxServiceDetailCode = this.items[this.items.length - 1].serviceDetailCode;
                let cal = 1;
                do {
                    if (this.maxServiceDetailCode == '10' && this.items.length > cal && this.isWaiting) {
                        this.maxServiceDetailCode = this.items[this.items.length - (cal + 1)].serviceDetailCode;
                    }
                    cal++;
                } while(this.maxServiceDetailCode == '10' && this.items.length > cal && this.isWaiting);
                        
                
                this.serviceStatus = this.editedItem.finishTime ? '1' : '0'; // check service is inProgress  0 = inProgress, 1 = finish
            } else {
                this.maxServiceDetailCode = 1;
            }
            
        },
        "editedItem.serviceDetailCode": function(newVal) {
            if (newVal == undefined) return;
            if (newVal.trim() == '9') { // val = 9 is mean serviceStatus = finish 
                this.serviceStatus = '1';
            }
        }
    },
    props: ["branchCode", "jobServiceDetail", "canEdit", "isWaiting", "canFinishJob"],
    data: () => ({
        isEdited: false,
        serviceStatus: '0',
        maxServiceDetailCode: '',
        dialog: false,
        validDetail: false,
        rules: rules,
        headers: [
            {text: 'No.', value: 'seq'},
            {text: 'ขั้นตอน', value: 'serviceDetailName'},
            {text: 'ช่าง', value: 'empFullname'},
            {text: 'เริ่มงาน', value: 'strBeginTime'},
            {text: 'สิ้นสุด', value: 'strEndTime'},
            {text: 'ใช้เวลา', value: 'totalMinute'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        serviceDetailList: [],
        empList: [],
        items: [],
        editedItem: {
            jobServiceDetailId: 0,
            serviceDetailCode: '',
            jobNo: '',
            empCode: '',
            startDate: '',
            startTime: '',
            finishDate: '',
            finishTime: '',
            revise: false,
            remark: ''
        },
        editedIndex: -1,
        isStopState: false,
    }),
    methods: {
        validateDateData() {

        },
        setStartDate(val) {
            this.editedItem.startDate = val;
            if (this.serviceStatus == '1' && (parseDate(val) > parseDate(this.editedItem.finishDate))) {
                this.$nextTick(() => {
                    this.$refs.finishDate.setDate(parseDate(val));
                });
                
            }
        },
        setFinishDate(val) {
            this.editedItem.finishDate = val;
        },
        deleteItem(item) {
            if (!confirm("ต้องการลบข้อมูลใช่หรือไม่ (เมื่อทำการลบระบบจะลบข้อมูลออกจากระบบทันที)")) return;
            let index = this.items.indexOf(item);
            this.items.splice(index, 1);
            if (item.jobServiceDetailId >= 0) {
                deleteJobServiceDetail(item.jobServiceDetailId);
            }
            if (this.items.length > 0) {
                this.items.forEach((e, row) => {
                    e.seq = row + 1;
                })
            }
        },
        editItem(item) {
            this.editedIndex = this.items.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
            this.$nextTick(() => {
                this.$refs.startDate.setDate(parseDate(item.startDate));
                if (this.serviceStatus == '1') {
                    this.$refs.finishDate.setDate(parseDate(item.finishDate));
                }
            });
        },
        saveDetail() {
            if (!this.$refs.formDetail.validate()) {
                return;
            }
            let valid = true;
            if (this.serviceStatus == '1') {
                
                if (this.editedItem.serviceDetailCode.trim() == '9') {
                    this.editedItem.strBeginTime = this.editedItem.finishDate + ' ' + this.editedItem.finishTime;
                    this.editedItem.strEndTime = this.editedItem.finishDate + ' ' + this.editedItem.finishTime;
                    let lDate = parseDate(this.editedItem.finishDate) + ' ' + this.editedItem.finishTime;
                    valid = moment(lDate).isBefore(new Date());
                } else {
                    this.editedItem.strBeginTime = this.editedItem.startDate + ' ' + this.editedItem.startTime;
                    this.editedItem.strEndTime = this.editedItem.finishDate + ' ' + this.editedItem.finishTime;
                    let fDate = parseDate(this.editedItem.startDate) + ' ' + this.editedItem.startTime;
                    let lDate = parseDate(this.editedItem.finishDate) + ' ' + this.editedItem.finishTime;
                    valid = moment(fDate).isBefore(lDate);
                    valid = valid && moment(lDate).isBefore(new Date());
                }
                
            } else { // on process state
                this.editedItem.strBeginTime = this.editedItem.startDate + ' ' + this.editedItem.startTime;
                let fDate = parseDate(this.editedItem.startDate) + ' ' + this.editedItem.startTime;
                valid = moment(fDate).isBefore(new Date());
            }

            if (!valid) {
                dialog.warn("ช่วงเวลาไม่ถูกต้อง");
                return;
            }
            
            let currServiceDetail = this.serviceDetailList.find(e => e.value.trim() == this.editedItem.serviceDetailCode.trim());
            this.editedItem.serviceDetailName = currServiceDetail.name;

            let emp = this.empList.find(e => e.value == this.editedItem.empCode);
            this.editedItem.empFullname = emp.name;
            if (this.editedIndex > -1) {
                Object.assign(this.items[this.editedIndex], this.editedItem);
            } else {
                this.editedItem.seq = this.items.length + 1;
                this.items.push(this.editedItem);
            }

            if (this.editedItem.serviceDetailCode == '10') {
                this.isStopState = true;
            }
            this.maxServiceDetailCode = this.editedItem.serviceDetailCode;
            this.isEdited = true;
            this.$emit("edited", true);
            this.closeDialog();
        },
        closeDialog() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, {});
                this.editedIndex = -1;
            });
        }
    },
    mounted() {
        listTechnicial(this.branchCode).then(rs => {
            this.empList = rs;
        });
        listServiceDetail().then(rs => {
            this.serviceDetailList = rs;
            if (this.serviceDetailList) {
                this.serviceDetailList = this.serviceDetailList.filter(o => parseInt(o.value.trim()) > 0);
            }
        });
        if (this.jobServiceDetail) {
            this.items = this.jobServiceDetail;
            if (this.items.length > 0) {
                this.items.forEach(o => {
                    if (o.strEndTime) {
                        let begin = moment(o.strBeginTime, 'DD-MM-YYYY HH:mm');
                        let end = moment(o.strEndTime, 'DD-MM-YYYY HH:mm');
                        let diff = end.diff(begin);
                        o.totalMinute = moment.utc(diff).format('HH:mm');
                    }
                    
                })
            }
        }
        this.isStopState = false;
    }
}
</script>